import {HighlightOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import LanguageManage from "../../../pages/script_manage/language_manage";

const ScriptRouter = [
    {
        path: '/Script',
        element: <Commonview/>,
        meta: {title: '话术管理', icon: <HighlightOutlined />},
        redirect: '/Script/language',
        hidden: true,
        children: [
            {
                path: '/Script/language',
                meta: {title: '话术管理', key: 'talk_script_management'},
                element: <LanguageManage/>,
            }
        ]
    }
]

export default ScriptRouter
